import React from 'react';
import { motion } from 'framer-motion';

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 12 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.4, delay, ease: [0.22, 1, 0.36, 1] },
});

const edu = [
  {
    degree: 'B.Tech in Computer Science',
    institution: 'BIT Jaipur',
    full: 'Birla Institute of Technology, Jaipur',
    duration: '2023 – 2027',
    status: 'Ongoing',
    gpa: '8.0',
    highlights: ['Data Structures & Algorithms', 'Operating Systems', 'Database Management', 'Computer Networks'],
    initials: 'BJ',
    color: '#7c3aed',
  },
  {
    degree: 'Class XII — Science (PCM)',
    institution: 'Subodh Public School',
    full: 'Subodh Public School',
    duration: '2021 – 2022',
    status: 'Completed',
    gpa: '90%',
    highlights: [],
    initials: 'SPS',
    color: '#0891b2',
  },
];

export default function Education() {
  return (
    <section id="education" className="relative w-full overflow-hidden bg-transparent py-8 lg:py-10">
      <div className="relative z-10 max-w-3xl mx-auto px-6 sm:px-10 lg:px-14">

        {/* Header */}
        <div className="flex items-end justify-between mb-6">
          <div>
            <motion.p {...fadeUp(0)} className="font-mono text-[10px] uppercase tracking-[0.2em] text-purple-600 font-bold mb-1">
              &lt;/Education&gt;
            </motion.p>
            <motion.h1 {...fadeUp(0.04)} className="text-2xl sm:text-3xl font-black text-black">
              Education
            </motion.h1>
          </div>
        </div>

        <motion.div {...fadeUp(0.08)} className="h-px bg-black/10 mb-0" />

        {/* Rows */}
        <div>
          {edu.map((e, i) => (
            <motion.div
              key={e.institution}
              {...fadeUp(0.1 + i * 0.07)}
              className="border-b border-black/8 last:border-0"
            >
              <div className="flex items-start gap-4 py-5">
                {/* Avatar */}
                <div
                  className="w-9 h-9 rounded-xl flex items-center justify-center text-white text-[11px] font-black shrink-0 shadow-[2px_2px_0px_0px_rgba(0,0,0,0.15)] mt-0.5"
                  style={{ background: e.color }}
                >
                  {e.initials}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2">
                    <div className="min-w-0">
                      <h3 className="text-[14px] font-black text-black leading-tight">{e.degree}</h3>
                      <p className="text-[11px] text-black/45 font-mono mt-0.5">{e.institution}</p>
                    </div>
                    <div className="text-right shrink-0">
                      <span className="text-[10px] font-mono text-black/35 block">{e.duration}</span>
                      <span className={`text-[9px] font-bold font-mono px-2 py-0.5 rounded-full mt-1 inline-block border ${
                        e.status === 'Ongoing'
                          ? 'bg-green-50 text-green-700 border-green-200'
                          : 'bg-black/4 text-black/40 border-black/8'
                      }`}>
                        {e.status}
                      </span>
                    </div>
                  </div>

                  {/* GPA + highlights */}
                  <div className="flex items-center gap-3 mt-2 flex-wrap">
                    <span className="text-[10px] font-mono font-bold text-purple-600">
                      {e.gpa.includes('%') ? 'Score' : 'GPA'}: {e.gpa}
                    </span>
                    {e.highlights.slice(0, 3).map(h => (
                      <span
                        key={h}
                        className="text-[9px] font-mono text-black/35 uppercase tracking-wide"
                      >
                        {h}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}